import styled, { css } from 'styled-components/macro'

import { IconButton } from '@loadsmart/loadsmart-ui'
import { Layout } from '@loadsmart/miranda-react'
import { getToken, toCSSValue } from '@loadsmart/miranda-react/dist/tokens'

import { sizes } from 'legacy/styles/screen'

export const ActionsWrapper = styled(Layout.Group)`
  margin-left: auto;
`

export const StyledIconButton = styled(IconButton)`
  margin-right: 16px;
`

export const ScrollWrapper = styled.div<{ $fixed: boolean }>`
  display: flex;
  justify-content: center;
  background-color: ${toCSSValue('color-background-primary')};

  @keyframes slideDown {
    from {
      transform: translateY(-100%);
    }
    to {
      transform: translateY(0);
    }
  }

  ${({ $fixed }) =>
    $fixed &&
    css`
      position: fixed;
      top: var(--navbar-height);
      left: 0;
      width: 100%;
      z-index: 10;
      border-bottom: ${toCSSValue('border-thin')} solid ${toCSSValue('color-border')};
      animation: slideDown 0.5s ease;
    `}
`

export const ContentWrapper = styled.div`
  display: flex;
  width: 100%;
  max-width: ${sizes['xxlg']};
  align-items: center;
  gap: ${getToken('spacing-4')};
  padding: ${getToken('spacing-4')};
  background-color: ${toCSSValue('color-background-primary')};
`
